import { object, string } from 'yup';

import { emailValidationSchema } from './emailValidationSchema';

export const loginValidationSchema = object({
  email: emailValidationSchema.required('Please enter your email').default(''),
  password: string().required('Please enter your password').default(''),
});
